import { render, staticRenderFns } from "./UcBillingDateRuleDisplay.yaml?vue&type=template&id=fb959064&component"
import script from "./UcBillingDateRuleDisplay.yaml?vue&type=script&lang=ts&component"
export * from "./UcBillingDateRuleDisplay.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports